export default __webpack_public_path__ + "assets/a56b05156cd733985f3d717833e3ff78.png";